
import React, { useRef, useContext, useEffect, useState, useMemo, useCallback } from "react";
import classNames from 'classnames';

import { observer } from "mobx-react";

import Form from 'react-bootstrap/Form';

import Skeleton from 'react-loading-skeleton'
import { useTranslation } from "react-i18next";
import { AsyncTypeahead } from 'react-bootstrap-typeahead'; // ES2015
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

//ARREGLAR ISVALID
const FormAutoComplete = (props) => {
    const { t } = useTranslation();
    const [value, setValue] = useState(null);
    //const [multiSelections, setMultiSelections] = useState([]);
    const isInvalid = () => !value?.id;
    const isInputInvalid = () => props.validated && isInvalid();

    const isValid = () => value?.id?.toString()?.length > 0 || false;

    
    //const isInputInvalid = () => props.validated && isInvalid();
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [query, setQuery] = useState('');
    const typeahead = useRef(null);

    useEffect(() => {
        var value = props.object?.[props.id];
        //var test = value && value != "" ? value : "";

        updateValues(value? [value]:null);

        /*if (props.multiple) {
            var selection = test ? test.split(',') : null;
            if (selection?.length > 0) {
                updateValues(selection)
            }
        }*/
        

    }, [props.object, props.multiple]);

    const updateValues = (e) => {
        
        setValue(e);
        //setField(e[0]?.id || "");
    }
    const handleInputChange = (q) => {
        setQuery(q);
    };

    const handleSearch = useCallback((q) => {

        setIsLoading(true);
        props.service?.(q).then((resp) => {
            //CACHE[q] = { ...resp, page: 1 };

            setIsLoading(false);
            setOptions(resp)
        });
    }, []);    

    return (
        /*AJUSTAR TODO PARA QUE LOS ITEMS SEAN ID/NAME*/
        <Form.Group controlId={props.id}>
            
            {props.isLoading ? <Skeleton /> : <Form.Label>{props.label}</Form.Label>}
            {props.isLoading  ? <Skeleton height={30} /> :
                <Stack direction="horizontal" gap={2}>
                    <div style={{width:"100%"}}>
                <AsyncTypeahead
                    
                    ref={typeahead}
                    inputProps={{ required: props.required }}
                    selected={value || []}
                    placeholder={props.placeholder || t("enterValue")}
                    id={props.id}
                    isLoading={isLoading}
                    labelKey={option => props.itemFn ? props.itemFn(option) : option.name}
                    filterBy={option => props.itemFn ? props.itemFn(option) : option.name}
                    onInputChange={handleInputChange}
                    /*onChange={updateValues}*/
                    onChange={selected => {
                        if (selected?.length == 0)
                            typeahead.current.clear();

                        updateValues(selected)                        
                    }
                    }
                    onSearch={handleSearch}
                    options={options}
                    disabled={props.disabled}
                    useCache={false}
                    isInvalid={isInputInvalid()}
                    isValid={isValid()}
                    renderMenuItemChildren={(option) => (
                        <div key={option.id}>
                            <span style={{ fontSize: "0.7rem" }}>{props.itemFn? props.itemFn(option): option.name}</span>
                        </div>
                        )}


                        />
                    </div>
                    {props.onCreateClick && <Button className="btn btn-secondary" onClick={()=>props.onCreateClick?.()}><FontAwesomeIcon icon={solid("plus")} /></Button>}
                </Stack>
            }
            
            {<Form.Control
                style={{display:"none"}}
                disabled={false}
                required={props.required}
                name={props.formId || props.id}
                placeholder={props.placeholder || t("enterValue")}
                value={value?.[0]?.id || ""} onChange={() => { }} />
            }
                

            <Form.Control.Feedback type="invalid">
                {t('fieldRequired')}
            </Form.Control.Feedback>

        </Form.Group>
    );
};

export default observer(FormAutoComplete);
